import { MarketApiResponse } from "src/model/shop.model";
import { AppState } from "..";
import { StateUpdaterMap } from "src/model/manager/state-manager";
import { getCurrentLanguage, getCurrentLanguageId, getCurrentLocale, getMarketId } from "src/utils/Market";
import { getLegalContent, getRestrictedAddressCodes, getShopId } from "src/utils/init/configuration";

export interface MarketActions {
    SHOP_MARKET_SET_CONFIG: MarketApiResponse
}

export const marketActions: StateUpdaterMap<AppState, MarketActions> = {
    SHOP_MARKET_SET_CONFIG: (market, _) => ({
        market: {
            locale: getCurrentLocale(market),
            languages: market?.languages,
            marketId: getMarketId(market),
            lang: getCurrentLanguage(market),
            langId: getCurrentLanguageId(market),
            expeditionDivision: market.expeditionDivision,
            rgpd: market?.rgpd,
            apiHost: market?.host,
            isMarketTaxes: market?.isMarketTaxes ?? false
        },
        store: {
            storeId: getShopId(market),
            restrictedAddressCodes: getRestrictedAddressCodes(market),
            legalContent: getLegalContent(market)
        }
    })
}
